import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useActions, useTypedSelector, useTranslation } from '../../../../../../../hooks'
import { ReportQuestionInterface } from '../../../../../../../ts/interfaces/ReportQuestionInterface'
import AddQuestionModal from '../../../../../../reusable/frames/innerframes/modal/AddQuestionModal'
import QuestionComponent from '../../../../../../reusable/frames/innerframes/modal/QuestionComponent'

const AddQuestionButton = styled.button`
    color: ${({ theme }) => theme.blue};
    background-color: rgba(36, 125, 208, 0.3);
    border: 1px solid rgba(36, 125, 208, 0.3);
    border-radius: 0.5rem;
    padding: 1rem 2rem;
    font-size: 1.8rem;
    margin-bottom: 2rem;

    &:hover {
        background-color: rgba(36, 125, 208, 0.7);
    }
`

interface PartnerReportQuestionsFrameProps {
    partnerId: number
    organizationId: number
}

const PartnerReportQuestionsFrame: React.FC<PartnerReportQuestionsFrameProps> = ({
    partnerId,
    organizationId,
}) => {
    const [isAddingQuestionModalOpen, setIsAddingQuestionModalOpen] =
        useState(false)
    const translation = useTranslation()
    const {
        addPartnerReportQuestion,
        getPartnerReportQuestions,
        putPartnerReportQuestion,
        deletePartnerReportQuestion,
    } = useActions()
    const { reportQuestions, reportQuestionsLoading } = useTypedSelector(
        (state) => state.reportQuestions
    )

    useEffect(() => {
        getPartnerReportQuestions(partnerId, organizationId)
        // eslint-disable-next-line
    }, [partnerId, organizationId])

    const handleAddReportQuestion = async (
        questionItem: ReportQuestionInterface
    ) => {
        const success = await addPartnerReportQuestion(
            partnerId,
            organizationId,
            questionItem
        )

        return success
    }

    const handleDelete = async (questionItem: ReportQuestionInterface) => {
        const success = await deletePartnerReportQuestion(
            partnerId,
            organizationId,
            questionItem
        )

        return success
    }

    const handleEdit = async (
        questionItem: ReportQuestionInterface,
        editedText: string
    ) => {
        const newQuestionItem = {
            ...questionItem,
            question: editedText,
        }
        const success = await putPartnerReportQuestion(
            partnerId,
            organizationId,
            newQuestionItem,
            newQuestionItem
        )

        return success
    }

    return (
        <>
            {isAddingQuestionModalOpen && (
                <AddQuestionModal
                    closeModal={() => setIsAddingQuestionModalOpen(false)}
                    handleAddReportQuestion={handleAddReportQuestion}
                    loading={reportQuestionsLoading}
                />
            )}
            <AddQuestionButton
                onClick={() => setIsAddingQuestionModalOpen(true)}
            >
                + {translation.clientView.addQuestion}
            </AddQuestionButton>

            {reportQuestions.map((questionItem: ReportQuestionInterface) => {
                return (
                    <QuestionComponent
                        key={questionItem.id}
                        index={questionItem.id}
                        reportQuestions={reportQuestions}
                        questionItem={questionItem}
                        handleDelete={handleDelete}
                        handleEdit={handleEdit}
                        loading={reportQuestionsLoading}
                    />
                )
            })}
        </>
    )
}

export default PartnerReportQuestionsFrame
